import { Drawer, PeachjarLoader } from '@/components';
import styles from './AccessibleVersion.styles';
import { BetaTag } from '@/components';
import { LanguageDropDown } from './LanguageDropDown';
import { useEffect, useState } from 'react';
import { Translator } from '@/utils/translation';
import { useAnalytics } from '@/hooks';
import { EventDetails, TrackingEvents, TrackingStage } from '@/config/tracking';

interface Props {
  wcagHtml?: string;
  isOpen: boolean;
  onToggle: (state: boolean) => void;
  preSelectedLanguage?: string;
}

export const AccessibleVersion: React.FC<Props> = ({
  wcagHtml,
  isOpen,
  onToggle,
  preSelectedLanguage = '',
}) => {
  const [selectedLanguage, setSelectedLanguage] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [textVersion, setTextVersion] = useState<string>('');
  const { trackEvent } = useAnalytics();

  useEffect(() => {
    if (isOpen) {
      if (preSelectedLanguage) {
        onSelectLanguage(preSelectedLanguage);
      } else {
        setTextVersion(wcagHtml || '');
      }
    } else {
      setSelectedLanguage('');
    }
  }, [isOpen, wcagHtml, preSelectedLanguage]);

  const onSelectLanguage = async (newLanguage: string) => {
    if (!process.env.REACT_APP_GOOGLE_API_KEY || !wcagHtml) return;
    setLoading(true);
    setSelectedLanguage(newLanguage);
    const translator = new Translator('en', process.env.REACT_APP_GOOGLE_API_KEY);
    const isHtml = true;
    const translatedText = await translator.translate(wcagHtml, newLanguage, isHtml);
    setTextVersion(translatedText);
    trackEvent({
      event: TrackingEvents.translate,
      event_detail: EventDetails.translateFlyerText,
      stage: TrackingStage.discovery,
    });
    setLoading(false);
  };

  return (
    <Drawer
      title={<BetaTag />}
      isOpen={isOpen}
      onToggle={onToggle}
      full
      headerChildren={
        <div style={{ position: 'absolute', left: 20, top: 20, zIndex: 9 }}>
          <LanguageDropDown
            selectedLanguage={selectedLanguage}
            setSelectedLanguage={onSelectLanguage}
          />
        </div>
      }
    >
      <div className={styles.container}>
        {loading && <PeachjarLoader loading />}
        {wcagHtml && !loading && (
          <div className="accessible-content" dangerouslySetInnerHTML={{ __html: textVersion }} />
        )}
      </div>
    </Drawer>
  );
};
